<template>
  <div class="outer-section Articles">
    <RwvArticleList :category="'blog'"></RwvArticleList>
  </div>
</template>

<script>
import RwvArticleList from '@/components/Articles/ArticleList.vue'

export default {
  title: "Blog | So wird's gemacht",
  name: 'blogs',
  components: {
    RwvArticleList
  }
}
</script>

<style lang="scss">
</style>
